import { LaunchDarklyProject } from '@square/ember-features/protos/squareup/feature/relay/flags/message/launch_darkly_project';
import { DataType } from '@square/dashboard-protos/models/squareup/feature/relay/common/data_type';

export const LAUNCH_DARKLY_FEATURE_FLAGS = [
  {
    flagName: 'banking/savings_show_fdic_logo',
    project: LaunchDarklyProject.PIE,
  },
  {
    flagName: 'dashboard/reimagined_nav_banking_variations',
    project: LaunchDarklyProject.PIE,
    type: DataType.STRING,
  },
  {
    flagName: 'uisystems-market-monochrome',
    project: LaunchDarklyProject.PIE,
  },
];

export enum ReimaginedNavBankingVariations {
  Test = 'A',
  Control = 'B',
  Holdout = 'C',
}
